import type { IntentRule } from '../api/IntentChecks';
import type { SnapshotId } from '../snapshot';
import { AbsurdError } from '../utils/absurd';
import type {
  GraphOverlayRequest,
  IntentGraphOverlayRequest,
} from './GraphOverlayRequest';

export interface CompareGraphOverlay {
  type: 'compare';
  snapshotToCompare: SnapshotId;
}

export interface IntentGraphOverlay {
  type: 'intent';
  intentRule: IntentRule;
}

export type GraphOverlay = CompareGraphOverlay | IntentGraphOverlay;

export const isCompareGraphOverlay = (
  overlay?: GraphOverlay | null,
): overlay is CompareGraphOverlay => overlay?.type === 'compare';

export const isIntentGraphOverlay = (
  overlay?: GraphOverlay | null,
): overlay is IntentGraphOverlay => overlay?.type === 'intent';

export const intentGraphOverlayToRequest = (
  overlay: IntentGraphOverlay,
): IntentGraphOverlayRequest => ({
  type: 'intent',
  intentRuleId: overlay.intentRule.id,
});

export const graphOverlayToRequest = (
  overlay: GraphOverlay | null,
): GraphOverlayRequest | undefined => {
  if (overlay === null) {
    return undefined;
  }
  if (isIntentGraphOverlay(overlay)) {
    return intentGraphOverlayToRequest(overlay);
  }
  if (isCompareGraphOverlay(overlay)) {
    return overlay;
  }
  throw new AbsurdError(overlay, 'unknown overlay type');
};
